import React from "react";
import logoPOS from "../assets/SVG/Logo_new.svg";
import bgSNS_invers from "../assets/SVG/bgSNS_invers.svg";
import {NavLink, useNavigate} from "react-router-dom";
import { NewClient } from "./NewClientSettings";
import { ApiResponse } from "@/types/Api";
import GenericApi from "@/api/genericApi";
import { useQuery } from "@tanstack/react-query";
import { ApiRoutes } from "@/config/routes/ApiRoutes";
import { useAppSelector } from "@/store";
import { NewClientPOSQueryKey } from "@/config/constants/QueryKeys";
import { Loader } from "lucide-react";
import {RoutesPathList} from "@/config/routes/Routes.tsx";
import {getUser, saveData} from "@/utils/localStorage.tsx";
import {authStorageUser, clientPosKey} from "@/config/constants/StorageKeys.tsx";
import { isSNS } from "@/utils/utils";
import footer_SNS from "../assets/SVG/footer_SNS.svg";


const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");

  return `${day}.${month}.${year} ${hour}:${minute}`;
};

const NewClientPOS: React.FC = () => {
  const refresh = useAppSelector((state) => state.refresh.refresh);
  const navigate = useNavigate();
  const [search, setSearch] = React.useState<string>("");

  const user = getUser();

  const { data: newClient, isLoading: newClientLoading } = useQuery<
    ApiResponse<NewClient[]>
  >({
    queryFn: async () => GenericApi.get<NewClient[]>(ApiRoutes.CLIENT),
    queryKey: [NewClientPOSQueryKey, refresh],
  });

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const filteredClientsBySearch = search
    ? newClient?.data?.filter((client) => {
        const fullName = `${client.first_name} ${client.last_name}`;
        return fullName.toLowerCase().includes(search.toLowerCase());
      })
    : newClient?.data;

  const logout = () => {
  localStorage.removeItem(authStorageUser);

  const loginPath = isSNS() ? RoutesPathList.SNSLogin : RoutesPathList.POSLogin;
  navigate(loginPath, { replace: true });
};

  if (newClientLoading) {
    return <Loader />;
  }
  

  return !isSNS() ? (
    <div className="overflow-x-hidden min-h-screen w-full bg-[#F3F3F3] flex flex-col justify-between items-center py-[2rem]">
      <div className="w-[25.125rem] justify-between flex items-center">
        <p className="text-[#222B45] text-[1.25rem] font-bold ml-[2rem]">
          {user?.business_info?.business_name || user?.business_name || "N/A"}
        </p>
        <svg
          onClick={logout}
          className="cursor-pointer mr-[2rem]"
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_4091_9588)">
            <path
              d="M1.65906 0.015148L8.3844 0C8.65065 0.010279 8.98819 0.264548 9.04652 0.524227C9.09674 0.747119 9.09242 2.04551 9.05516 2.29491C9.01249 2.58002 8.66848 2.85268 8.3844 2.86459L3.48068 2.86567C3.18418 2.90354 2.87311 3.22976 2.85637 3.53596L2.86987 19.562C2.91469 19.8173 3.22145 20.1051 3.48068 20.1381L8.3844 20.1392C8.69602 20.1619 9.00817 20.3886 9.05516 20.7089C9.10214 21.0291 9.09998 22.1285 9.05516 22.4341C9.01681 22.6954 8.77649 22.9145 8.534 22.9924L1.59425 22.9995C0.813328 22.8739 0.201982 22.2659 0.0118813 21.5068L0 1.6468C0.131774 0.790939 0.795506 0.12984 1.65906 0.015148Z"
              fill="#202A43"
            />
            <path
              d="M15.821 4.29248C15.9911 4.29519 16.2044 4.39743 16.334 4.50888L22.7753 10.9614C22.994 11.2589 23.0745 11.4634 22.919 11.8097C22.724 12.2441 21.8691 12.8992 21.5062 13.2557C19.7262 15.0026 17.9942 16.7939 16.199 18.5224C15.8615 18.7539 15.5277 18.6549 15.228 18.4142C14.9979 18.2291 14.217 17.4409 14.1203 17.2023C14.0102 16.9318 14.0572 16.6721 14.2305 16.4428C14.5978 15.9575 15.3198 15.3732 15.7686 14.9058C15.8318 14.8398 15.8642 14.7532 15.9274 14.6872C16.1353 14.4692 17.0334 13.6588 17.0777 13.464C17.1463 13.16 16.9389 12.883 16.6316 12.8511H6.33541C6.01191 12.7818 5.78023 12.487 5.72568 12.1667C5.67708 11.8827 5.67924 10.857 5.7381 10.5827C5.81155 10.2429 6.1021 10.0233 6.44018 9.98973L16.6851 9.99352C17.0685 9.96809 17.2068 9.53746 17.0043 9.23775L14.3099 6.53708C14.0744 6.25252 13.9843 5.94956 14.2051 5.61955C14.3348 5.42641 15.1583 4.61492 15.3609 4.45586C15.497 4.34929 15.6433 4.29032 15.8205 4.29302L15.821 4.29248Z"
              fill="#202A43"
            />
          </g>
          <defs>
            <clipPath id="clip0_4091_9588">
              <rect width="23" height="23" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="bg-white px-[1rem] py-[1rem] w-[21.125rem] h-[23.3125rem] rounded-[0.625rem] mt-[2rem]">
        <div className="flex items-center gap-3 pb-2 pl-2">
          <svg
            className="w-5 h-5 text-gray-700"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M19.6146 18.3641L15.8489 14.6096C17.0639 13.0617 17.7231 11.1503 17.7207 9.18261C17.7207 7.4302 17.201 5.71714 16.2275 4.26007C15.2539 2.80299 13.8701 1.66734 12.2511 0.996723C10.632 0.326105 8.85052 0.15064 7.13178 0.492519C5.41304 0.834397 3.83428 1.67826 2.59514 2.9174C1.356 4.15654 0.512131 5.73531 0.170253 7.45405C-0.171625 9.17278 0.00383902 10.9543 0.674457 12.5733C1.34508 14.1923 2.48073 15.5761 3.9378 16.5497C5.39488 17.5233 7.10794 18.043 8.86035 18.043C10.8281 18.0454 12.7395 17.3862 14.2873 16.1712L18.0419 19.9369C18.1448 20.0407 18.2673 20.1231 18.4023 20.1793C18.5373 20.2355 18.682 20.2645 18.8282 20.2645C18.9744 20.2645 19.1192 20.2355 19.2542 20.1793C19.3891 20.1231 19.5116 20.0407 19.6146 19.9369C19.7184 19.8339 19.8008 19.7114 19.857 19.5764C19.9132 19.4415 19.9422 19.2967 19.9422 19.1505C19.9422 19.0043 19.9132 18.8595 19.857 18.7246C19.8008 18.5896 19.7184 18.4671 19.6146 18.3641ZM2.21509 9.18261C2.21509 7.8683 2.60483 6.58351 3.33502 5.49071C4.06521 4.3979 5.10306 3.54616 6.31732 3.0432C7.53158 2.54023 8.86772 2.40863 10.1568 2.66504C11.4458 2.92145 12.6299 3.55435 13.5593 4.48371C14.4886 5.41306 15.1215 6.59713 15.3779 7.88619C15.6343 9.17524 15.5027 10.5114 14.9998 11.7256C14.4968 12.9399 13.6451 13.9777 12.5523 14.7079C11.4594 15.4381 10.1747 15.8279 8.86035 15.8279C7.09791 15.8279 5.40767 15.1277 4.16144 13.8815C2.91521 12.6353 2.21509 10.945 2.21509 9.18261Z"
              fill="#202A43"
            />
          </svg>
          <input
            type="text"
            placeholder="Search client"
            value={search}
            onChange={handleSearch}
            className="flex-1 bg-transparent border-b border-gray-400 focus:outline-none outline-none border-none focus:border-blue-500 text-sm text-gray-800 border-transparent focus:border-transparent focus:ring-0"
          />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="332"
          height="2"
          viewBox="0 0 332 2"
          fill="none"
        >
          <path d="M0 1L332 1.00003" stroke="#737791" stroke-opacity="0.15" />
        </svg>
        <div className="flex h-full justify-between pt-[1rem]">
          <div className="flex flex-col overflow-y-scroll max-h-[17rem] w-full h-fit crypto-list">
            {filteredClientsBySearch?.map((client) => (
              <div
                onClick={() => {
                  saveData(clientPosKey, {
                    client_id: client?.id ?? null,
                  });

                  navigate(RoutesPathList.ExchangePhone);
                }}
                key={client.id}
                className="cursor-pointer pr-4 flex flex-row justify-between items-center px-[0.5rem] mb-[1rem]"
              >
                <div className="text-[#222B45] text-[1.1875rem] font-[500] p-2">
                  {client.first_name} {client.last_name}
                </div>
                <span className="text-[1.1875rem] font-[400] text-[#737791] text-opacity-35">
                  {formatDate(client.created_at)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <NavLink to={RoutesPathList.ScanIDPOS}>
        <div className="bg-[#202A43] mt-[1.2rem] px-[8rem] py-[1rem] w-[21.125rem] h-[15.1875rem] rounded-[0.625rem] flex flex-col items-center gap-4 justify-center">
          <svg
            className="w-[3.125rem] h-[3.125rem]"
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
          >
            <circle cx="25" cy="25" r="23" stroke="white" stroke-width="4" />
            <path
              d="M26.7081 22.3535C26.7081 22.6381 26.7793 22.8657 26.9216 23.0365C27.0923 23.1788 27.32 23.2499 27.6046 23.2499H35.2884C35.573 23.2499 35.7864 23.3353 35.9287 23.5061C36.0995 23.6483 36.1848 23.8618 36.1848 24.1464V25.8112C36.1848 26.0958 36.0995 26.3235 35.9287 26.4942C35.7864 26.6365 35.573 26.7076 35.2884 26.7076H27.6046C27.32 26.7076 27.0923 26.793 26.9216 26.9638C26.7793 27.1061 26.7081 27.3195 26.7081 27.6041V35.2879C26.7081 35.5725 26.6228 35.8001 26.452 35.9709C26.3097 36.1132 26.0963 36.1843 25.8117 36.1843H24.1469C23.8623 36.1843 23.6346 36.1132 23.4639 35.9709C23.3216 35.8001 23.2504 35.5725 23.2504 35.2879V27.6041C23.2504 27.3195 23.165 27.1061 22.9943 26.9638C22.852 26.793 22.6386 26.7076 22.354 26.7076H14.7129C14.4283 26.7076 14.2006 26.6365 14.0298 26.4942C13.8876 26.3235 13.8164 26.0958 13.8164 25.8112V24.1464C13.8164 23.8618 13.8876 23.6483 14.0298 23.5061C14.2006 23.3353 14.4283 23.2499 14.7129 23.2499H22.354C22.6386 23.2499 22.852 23.1788 22.9943 23.0365C23.165 22.8657 23.2504 22.6381 23.2504 22.3535V14.7124C23.2504 14.4278 23.3216 14.2143 23.4639 14.072C23.6346 13.9013 23.8623 13.8159 24.1469 13.8159H25.8117C26.0963 13.8159 26.3097 13.9013 26.452 14.072C26.6228 14.2143 26.7081 14.4278 26.7081 14.7124V22.3535Z"
              fill="white"
            />
          </svg>

          <div className="client text-center w-[10rem] text-white font-satoshi">
            New client
          </div>
        </div>
      </NavLink>
      <div className="w-full flex justify-center items-center mt-[8rem]">
        <img draggable="false" src={logoPOS} alt="logo" />
      </div>
    </div>
  ) : (
    <div
      className="overflow-x-hidden min-h-screen relative w-full font-[helvetica] flex flex-col justify-between items-center py-[2rem] bg-[#1C1C1C] bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgSNS_invers})`,
      }}
    >
      <div className="w-[25.125rem] justify-between flex items-center">
        <p className="text-[#8AFEFD] text-[1.25rem] font-bold ml-[2rem]">
          {user?.business_info?.business_name || user?.business_name || "N/A"}
        </p>
        <svg
          onClick={logout}
          className="cursor-pointer mr-[2rem]"
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_4091_9588)">
            <path
              d="M1.65906 0.015148L8.3844 0C8.65065 0.010279 8.98819 0.264548 9.04652 0.524227C9.09674 0.747119 9.09242 2.04551 9.05516 2.29491C9.01249 2.58002 8.66848 2.85268 8.3844 2.86459L3.48068 2.86567C3.18418 2.90354 2.87311 3.22976 2.85637 3.53596L2.86987 19.562C2.91469 19.8173 3.22145 20.1051 3.48068 20.1381L8.3844 20.1392C8.69602 20.1619 9.00817 20.3886 9.05516 20.7089C9.10214 21.0291 9.09998 22.1285 9.05516 22.4341C9.01681 22.6954 8.77649 22.9145 8.534 22.9924L1.59425 22.9995C0.813328 22.8739 0.201982 22.2659 0.0118813 21.5068L0 1.6468C0.131774 0.790939 0.795506 0.12984 1.65906 0.015148Z"
              fill="#8AFEFD"
            />
            <path
              d="M15.821 4.29248C15.9911 4.29519 16.2044 4.39743 16.334 4.50888L22.7753 10.9614C22.994 11.2589 23.0745 11.4634 22.919 11.8097C22.724 12.2441 21.8691 12.8992 21.5062 13.2557C19.7262 15.0026 17.9942 16.7939 16.199 18.5224C15.8615 18.7539 15.5277 18.6549 15.228 18.4142C14.9979 18.2291 14.217 17.4409 14.1203 17.2023C14.0102 16.9318 14.0572 16.6721 14.2305 16.4428C14.5978 15.9575 15.3198 15.3732 15.7686 14.9058C15.8318 14.8398 15.8642 14.7532 15.9274 14.6872C16.1353 14.4692 17.0334 13.6588 17.0777 13.464C17.1463 13.16 16.9389 12.883 16.6316 12.8511H6.33541C6.01191 12.7818 5.78023 12.487 5.72568 12.1667C5.67708 11.8827 5.67924 10.857 5.7381 10.5827C5.81155 10.2429 6.1021 10.0233 6.44018 9.98973L16.6851 9.99352C17.0685 9.96809 17.2068 9.53746 17.0043 9.23775L14.3099 6.53708C14.0744 6.25252 13.9843 5.94956 14.2051 5.61955C14.3348 5.42641 15.1583 4.61492 15.3609 4.45586C15.497 4.34929 15.6433 4.29032 15.8205 4.29302L15.821 4.29248Z"
              fill="#8AFEFD"
            />
          </g>
          <defs>
            <clipPath id="clip0_4091_9588">
              <rect width="23" height="23" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="bg-[#383838] px-[1rem] py-[1rem] w-[21.125rem] h-[23.3125rem] rounded-[0.625rem] mt-[2rem] ">
        <div className="flex items-center gap-3 pb-2 pl-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
          >
            <path
              d="M19.6146 18.3641L15.8489 14.6096C17.0639 13.0617 17.7231 11.1503 17.7207 9.18261C17.7207 7.4302 17.201 5.71714 16.2275 4.26007C15.2539 2.80299 13.8701 1.66734 12.2511 0.996723C10.632 0.326105 8.85052 0.15064 7.13178 0.492519C5.41304 0.834397 3.83428 1.67826 2.59514 2.9174C1.356 4.15654 0.512131 5.73531 0.170253 7.45405C-0.171625 9.17278 0.00383902 10.9543 0.674457 12.5733C1.34508 14.1923 2.48073 15.5761 3.9378 16.5497C5.39488 17.5233 7.10794 18.043 8.86035 18.043C10.8281 18.0454 12.7395 17.3862 14.2873 16.1712L18.0419 19.9369C18.1448 20.0407 18.2673 20.1231 18.4023 20.1793C18.5373 20.2355 18.682 20.2645 18.8282 20.2645C18.9744 20.2645 19.1192 20.2355 19.2542 20.1793C19.3891 20.1231 19.5116 20.0407 19.6146 19.9369C19.7184 19.8339 19.8008 19.7114 19.857 19.5764C19.9132 19.4415 19.9422 19.2967 19.9422 19.1505C19.9422 19.0043 19.9132 18.8595 19.857 18.7246C19.8008 18.5896 19.7184 18.4671 19.6146 18.3641ZM2.21509 9.18261C2.21509 7.8683 2.60483 6.58351 3.33502 5.49071C4.06521 4.3979 5.10306 3.54616 6.31732 3.0432C7.53158 2.54023 8.86772 2.40863 10.1568 2.66504C11.4458 2.92145 12.6299 3.55435 13.5593 4.48371C14.4886 5.41306 15.1215 6.59713 15.3779 7.88619C15.6343 9.17524 15.5027 10.5114 14.9998 11.7256C14.4968 12.9399 13.6451 13.9777 12.5523 14.7079C11.4594 15.4381 10.1747 15.8279 8.86035 15.8279C7.09791 15.8279 5.40767 15.1277 4.16144 13.8815C2.91521 12.6353 2.21509 10.945 2.21509 9.18261Z"
              fill="#8AFEFD"
            />
          </svg>
          <input
            type="text"
            placeholder="Search client"
            value={search}
            onChange={handleSearch}
            className="flex-1 text-[#94949459] bg-transparent border-b border-gray-400 focus:outline-none outline-none border-none text-[1rem] focus:border-blue-500 text-sm text-white border-transparent focus:border-transparent focus:ring-0"
          />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="310"
          height="2"
          viewBox="0 0 310 2"
          fill="none"
        >
          <path d="M0 1L332 1.00003" stroke="#737791" stroke-opacity="0.15" />
        </svg>
        <div className="flex h-full justify-between pt-[1rem]">
          <div
            className="flex flex-col overflow-y-scroll max-h-[17rem] w-full h-fit crypto-list"
            style={
              {
                "--scrollbar-thumb-color": !isSNS() ? "#202A43" : "#8AFEFD",
                "--scrollbar-track-color": !isSNS() ? "#f7f4ed" : "#1C1C1C",
              } as React.CSSProperties
            }
          >
            {filteredClientsBySearch?.map((client) => (
              <div
                onClick={() => {
                  saveData(clientPosKey, {
                    client_id: client?.id ?? null,
                  });

                  navigate(RoutesPathList.ExchangePhone);
                }}
                key={client.id}
                className="cursor-pointer pr-4 flex flex-row justify-between items-center px-[0.5rem] mb-[1rem]"
              >
                <div className="text-[#fff] text-[1rem] font-[500] p-2">
                  {client.first_name} {client.last_name}
                </div>
                <span className="text-[1rem] font-[400] text-[#949494] text-opacity-35">
                  {formatDate(client.created_at)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <NavLink to={RoutesPathList.ScanIDSNS}>
        <div className="bg-[#1C1C1C] mt-[1.2rem] z-20 border border-[#8AFEFDAD] px-[8rem] py-[1rem] w-[21.125rem] h-[15.1875rem] rounded-[0.625rem] flex flex-col items-center gap-4 justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
          >
            <circle
              cx="25"
              cy="25"
              r="23"
              stroke="#8AFEFD"
              stroke-width="4"
            />
            <path
              d="M26.7081 22.354C26.7081 22.6386 26.7793 22.8662 26.9216 23.037C27.0923 23.1793 27.32 23.2504 27.6046 23.2504H35.2884C35.573 23.2504 35.7864 23.3358 35.9287 23.5065C36.0995 23.6488 36.1848 23.8623 36.1848 24.1469V25.8117C36.1848 26.0963 36.0995 26.3239 35.9287 26.4947C35.7864 26.637 35.573 26.7081 35.2884 26.7081H27.6046C27.32 26.7081 27.0923 26.7935 26.9216 26.9643C26.7793 27.1066 26.7081 27.32 26.7081 27.6046V35.2884C26.7081 35.573 26.6228 35.8006 26.452 35.9714C26.3097 36.1137 26.0963 36.1848 25.8117 36.1848H24.1469C23.8623 36.1848 23.6346 36.1137 23.4639 35.9714C23.3216 35.8006 23.2504 35.573 23.2504 35.2884V27.6046C23.2504 27.32 23.165 27.1066 22.9943 26.9643C22.852 26.7935 22.6386 26.7081 22.354 26.7081H14.7129C14.4283 26.7081 14.2006 26.637 14.0298 26.4947C13.8876 26.3239 13.8164 26.0963 13.8164 25.8117V24.1469C13.8164 23.8623 13.8876 23.6488 14.0298 23.5065C14.2006 23.3358 14.4283 23.2504 14.7129 23.2504H22.354C22.6386 23.2504 22.852 23.1793 22.9943 23.037C23.165 22.8662 23.2504 22.6386 23.2504 22.354V14.7129C23.2504 14.4283 23.3216 14.2148 23.4639 14.0725C23.6346 13.9018 23.8623 13.8164 24.1469 13.8164H25.8117C26.0963 13.8164 26.3097 13.9018 26.452 14.0725C26.6228 14.2148 26.7081 14.4283 26.7081 14.7129V22.354Z"
              fill="#8AFEFD"
             
            />
          </svg>

          <div className="client text-center w-[10rem]">New client</div>
        </div>
      </NavLink>
      <div className="w-full flex justify-center items-center mt-[8rem]">
        <img
          draggable="false"
          src={footer_SNS}
          alt="logo"
          className="w-[6rem] h-[4rem]"
        />
      </div>
    </div>
  );
};

export default NewClientPOS;
